import type { Theme } from '@mui/material/styles';
import type { SystemStyleObject } from '@mui/system';

/** Clickable browse card shell — onClick + navigate (same pattern as games/replay rows). */
export const clickableCardShellSx: SystemStyleObject<Theme> = {
  position: 'relative',
  width: '100%',
  isolation: 'isolate',
  overflow: 'hidden',
  cursor: 'pointer',
  touchAction: 'manipulation',
  WebkitTapHighlightColor: 'transparent',
  textDecoration: 'none',
  color: 'inherit',
};

/** Nested interactive control inside a clickable card (buttons, links). */
export const clickableCardInteractiveChildSx: SystemStyleObject<Theme> = {
  position: 'relative',
  zIndex: 2,
  pointerEvents: 'auto',
};

/** Preview-board wrappers — chessboard DOM must not intercept card taps. */
export const previewBoardPointerBlockSx: SystemStyleObject<Theme> = {
  pointerEvents: 'none',
  '& *': { pointerEvents: 'none' },
};
